import { Component, createSignal, createEffect } from "solid-js";
import styles from './index.module.css';

type Props = { value: string; max: number }

export const CharacterCount : Component<Props> = (props) => {
    const [value, setValue] = createSignal<string>("");
    createEffect(() => (props.value)? setValue(props.value) : setValue(""));
    return (<span classList={{ [styles.error]: value().length > props.max }}>{value().length}/{props.max}</span>)
};